import React from "react";
const CategoryCampaignButtonGroup = (props) => {
    return (
        <>
            <div className="grid grid-cols-12 gap-6">
                <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                    <div className="flex justify-start">
                        <div className="h-full pb-1">

                            <button
                                className="btn btn-theme-dark-border text-[#81A3B8]"
                                onClick={props.editDetails}
                            >
                                <span className="text-xl font-semibold tracking-normal">
                                    Edit Details
                                </span>
                            </button>

                        </div>
                    </div>
                </div>
                <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                    <div className="flex justify-end">
                        <div className="px-4">
                            <div className="h-full pb-1">
                                <button className="btn btn-gray text-white" onClick={() => props.redirectToViewEntries()}>
                                    <p className="tracking-normal">
                                        Cancel
                                    </p>
                                </button>
                            </div>
                        </div>
                        <div className="px-4">
                            <div className="h-full pb-1">
                                <button
                                    className="btn btn-theme-dark text-white"
                                    onClick={() => props.addEditCampaignTaggingDetails(2)}
                                >
                                    <p className="tracking-normal">
                                        Save
                                    </p>
                                </button>
                            </div>
                        </div>
                        <div className="px-4">
                            <div className="h-full pb-1">
                                <button
                                    className="btn btn-red text-white"
                                    onClick={() => props.addEditCampaignTaggingDetails(12)}
                                >
                                    <p className="tracking-normal">
                                        Approve
                                    </p>
                                </button>
                            </div>
                        </div>
                        {
                            props.eventStatusId === 12 || props.eventStatusId == 2 ? null :
                        <div className="px-4">
                            <div
                                className="h-full pb-1 pt-4"
                                onClick={() => props.addEditCampaignTaggingDetails(1)}
                            >
                                <button>
                                    <p className="text-[#81A3B8] tracking-normal">
                                        Draft
                                    </p>
                                </button>
                            </div>
                        </div>
                         } 
                    </div>
                </div>
            </div>
        </>
    );
}
export default CategoryCampaignButtonGroup;